import { Routes, Route, useNavigate } from "react-router-dom";
import { Quiz361, Quiz362, Quiz381, Quiz382 } from "./Quiz736";
import { getCookie } from "../../support/Cookie";

export default function Quiz7() {
  const navigate = useNavigate();
  if (!(Number(getCookie("role")) > 0)) {
    navigate("/login");
  }
  return (
    <>
      <h1>도움 받아 해결하기</h1>
      <Routes>
        <Route path="1" element={<Quiz361 />} />
        <Route path="2" element={<Quiz362 />} />
        <Route path="3" element={<Quiz381 />} />
        <Route path="4" element={<Quiz382 />} />
      </Routes>
    </>
  );
}
